var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHengjia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_1894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5.00009L9.85547 11.035",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03076 2.37686L9.85541 11.035",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 2.00003L5.75 10",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 3.5L9.85547 11.0351",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2502 5.00009L12.8032 12.2632",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03086 2.25403L1.75 8.08754L15.75 13L13.75 5L7.03086 2.25403Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHengjia);
export default __webpack_public_path__ + "static/media/hengjia.2c4f8aa8e5ec29288282481a71ab5fb7.svg";
export { ForwardRef as ReactComponent };